import MarketingContentPage from "@/components/marketing/MarketingContentPage"

export default function Security() {
  return <MarketingContentPage pageKey="security" seoKey="security" />
}
